<template>
  <div class="big">
    <div class="page_title">平台养生方管理</div>
    <div style="padding: 20px">
      <div class="container">
        <div class="searchbox">
          <div class="item">
            <el-button plain @click="hospitaldia = true">药房筛选</el-button>
          </div>
          <div class="item">
            <span>养生方编号</span>
            <el-input
              placeholder="请输入"
              v-model="oil_code"
              style="width: 140px; margin-left: 10px"
              @input="search"
            ></el-input>
          </div>
          <div class="item">
            <span>养生方名称</span>
            <el-input
              placeholder="请输入"
              v-model="oil_name"
              style="width: 140px; margin-left: 10px"
              @input="search"
            ></el-input>
          </div>
          <div class="item">
            <span>创建时间</span>
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              style="width: 225px; margin-left: 12px"
              @change="search"
            ></el-date-picker>
          </div>
          <div class="item">
            <span>审核状态</span>
            <el-select
              v-model="reviewed_status"
              placeholder="请选择"
              style="width: 140px; margin-left: 10px"
              @change="search"
            >
              <el-option
                v-for="(item, index) in reviewed_status_list"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="item">
            <span>养生方状态</span>
            <el-select
              v-model="status"
              placeholder="请选择"
              style="width: 140px; margin-left: 10px"
              @change="search"
              clearable
            >
              <el-option
                v-for="(item, index) in status_list"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="item">
            <span>上架状态</span>
            <el-select
              v-model="buy_status"
              placeholder="请选择"
              style="width: 140px; margin-left: 10px"
              @change="search"
              clearable
            >
              <el-option label="全部" :value="0"></el-option>
              <el-option label="上架" :value="1"></el-option>
              <el-option label="下架" :value="2"></el-option>
            </el-select>
          </div>
          <div class="item">
            <span>养生方分类</span>
            <el-select
              v-model="category_id"
              placeholder="请选择"
              style="width: 140px; margin-left: 10px"
              @change="search"
            >
              <el-option
                v-for="(item, index) in categoryList"
                :key="index"
                :label="item.category_name"
                :value="item.category_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div style="margin: 12px 0 16px 0" class="flex between">
          <div>
            <el-button
              type="primary"
              style="width: 96px"
              @click="search"
              size="medium"
              >查询</el-button
            >
            <el-button
              plain
              style="width: 96px"
              @click="clearSearch"
              size="medium"
              >重置</el-button
            >
          </div>
          <div>
            <el-button
              type="primary"
              style="width: 120px"
              size="medium"
              @click="addShow = true"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('707') : false
              "
              >新建养生方</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            @selection-change="handleSelectionChange"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column
              prop="hospital_name"
              label="药房名称"
            ></el-table-column>
            <el-table-column
              label="养生方编号"
              prop="oil_code"
            ></el-table-column>
            <el-table-column
              prop="oil_name"
              label="养生方名称"
            ></el-table-column>
            <el-table-column prop="category" label="分类">
              <template slot-scope="scope">
                <div v-for="(item, index) in scope.row.category" :key="index">
                  {{ item.category_name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="oil_spec" label="规格"></el-table-column>
            <el-table-column prop="oil_unit" label="单位"></el-table-column>
            <el-table-column prop="cost_price" label="成本价"></el-table-column>
            <el-table-column label="销售价">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.price"
                  style="width: 100px"
                  v-if="scope.row.edit && scope.row.reviewed_status != 1"
                ></el-input>
                <span @dblclick="scope.row.edit = true" v-else>{{
                  scope.row.price
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="理论库存">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.stock"
                  style="width: 100px"
                  v-if="scope.row.edit && scope.row.reviewed_status != 1"
                ></el-input>
                <span @dblclick="scope.row.edit = true" v-else>{{
                  scope.row.stock
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="审核状态">
              <template slot-scope="scope">
                <span v-if="scope.row.reviewed_status == 1">审核中</span>
                <span v-if="scope.row.reviewed_status == 2">已通过</span>
                <span v-if="scope.row.reviewed_status == 3">未通过</span>
              </template>
            </el-table-column>
            <el-table-column label="上架状态">
              <template slot-scope="scope">
                <span v-if="scope.row.buy_status == 1">上架</span>
                <span v-if="scope.row.buy_status == 2">下架</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
            ></el-table-column>

            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <div v-if="scope.row.edit && scope.row.reviewed_status != 1">
                  <el-button
                    type="primary"
                    @click="editGoods(scope.row)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('717')
                        : false
                    "
                    >提交</el-button
                  >
                  <el-button plain @click="scope.row.edit = false"
                    >取消</el-button
                  >
                </div>
                <div v-else>
                  <el-button
                    type="text"
                    @click="
                      editGaofang(scope.row.oil_id, scope.row.hospital_name)
                    "
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('706')
                        : false
                    "
                    v-if="
                      scope.row.reviewed_status == 2 ||
                      scope.row.reviewed_status == 3
                    "
                    >编辑</el-button
                  >

                  <el-button
                    v-if="scope.row.buy_status == 2"
                    @click="upSell(scope.row.oil_id)"
                    type="text"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('708')
                        : false
                    "
                    >上架</el-button
                  >

                  <el-button
                    @click="OffTheShelves(scope.row.oil_id)"
                    type="text"
                    v-if="scope.row.buy_status == 1"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('708')
                        : false
                    "
                    >下架</el-button
                  >

                  <el-button
                    @click="delGoods(scope.row.oil_id)"
                    type="text"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('709')
                        : false
                    "
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="btnbox">
          <el-checkbox
            v-model="checked"
            style="margin-right: 24px"
            @change="toggleSelection"
            >全选</el-checkbox
          >
          <el-button
            @click="upSellAll"
            size="medium"
            plain
            :disabled="
              module_id_array[0] ? !module_id_array.includes('708') : false
            "
            >上架</el-button
          >
          <el-button
            @click="OffTheShelvesAll"
            size="medium"
            plain
            :disabled="
              module_id_array[0] ? !module_id_array.includes('708') : false
            "
            >下架</el-button
          >
          <el-button
            @click="delAll"
            size="medium"
            plain
            :disabled="
              module_id_array[0] ? !module_id_array.includes('709') : false
            "
            >删除</el-button
          >
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
    <AddGaofang v-if="addShow" @closeDialog="closeDialog"></AddGaofang>
    <EditGaofang
      v-if="editShow"
      @closeDialog="closeDialog"
      :oil_id="currentId"
      :hospitalName="hospitalName"
    ></EditGaofang>
    <el-dialog
      title="药房筛选"
      :visible.sync="hospitaldia"
      width="540px"
      style="text-align: left"
      :close-on-click-modal="false"
    >
      <div class="mycheck dialog">
        <el-checkbox-group v-model="checkList">
          <el-checkbox
            :label="item.hospital_id"
            v-for="(item, index) in hospitalList"
            :key="index"
            >{{ item.hospital_name }}</el-checkbox
          >
        </el-checkbox-group>
        <div style="margin-top: 20px; text-align: right">
          <el-button plain @click="closeDia" size="medium">取消</el-button>
          <el-button type="primary" @click="chooseHospital" size="medium"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AddGaofang from "./AddGaofang.vue";
import EditGaofang from "./EditGaofang.vue";
import platform from "../../../api/platform";
import dayjs from "dayjs";

export default {
  name: "gaofangList",
  data() {
    return {
      status: 0,
      currentPage: 1,
      totalNum: 0,
      pagesize: 10,
      tableData: [],
      hospitalList: [],
      hospitaldia: false,
      checkList: [],
      hospital_id: "",
      oil_name: "",
      oil_code: "",
      buy_status: 0,
      date: [],
      category_id: "",
      reviewed_status: 0,
      currentId: "", //当前选择编辑的id
      selectedId: "",
      selectedIdArr: [],
      checked: false, //全选
      reviewed_status_list: [
        { label: "全部", value: 0 },
        { label: "审核中", value: 1 },
        { label: "已通过", value: 2 },
        { label: "未通过", value: 3 },
      ],
      status_list: [
        { label: "全部", value: 0 },
        { label: "在售", value: 1 },
        { label: "仓库", value: 2 },
        { label: "售罄", value: 3 },
      ],
      addShow: false,
      editShow: false,
      categoryList: [], //分类列表
      hospitalName: "",
    };
  },
  components: { AddGaofang, EditGaofang },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array || [];
    },
  },
  created() {
    this.getList();
    this.getMedicineOintmentCategory();
    this.getHospital();
  },
  methods: {
    //获取药房列表
    getHospital() {
      this.axios
        .post("platform/hospital/getHospitaList", {
          page: 1,
          pageNumber: 10000,
        })
        .then((res) => {
          this.hospitalList = res.data.list;
        });
    },
    //关闭药房删选弹窗
    closeDia() {
      this.checkList = [];
      this.hospital_id = "";
      this.hospitaldia = false;
    },
    //获取养生方列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        status: this.status,
        oil_code: this.oil_code,
        oil_name: this.oil_name,
        category_id: this.category_id,
        reviewed_status: this.reviewed_status,
        hospital_id: this.hospital_id,
        buy_status: this.buy_status,
      };
      if (this.date && this.date.length > 0) {
        data.create_time_start = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.create_time_end = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      this.axios
        .post("platform/Goods/getHospitalOintmentList", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.create_time = platform.timestampToTime(item.create_time);
              item.edit = false;
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    //搜索
    search(value) {
      this.currentPage = 1;
      this.getList();
    },
    //筛选药房
    chooseHospital() {
      if (this.checkList.length) {
        this.hospital_id = this.checkList.toString();
        this.hospitaldia = false;
        this.getList();
      }
    },
    //重置
    clearSearch() {
      this.hospital_id = "";
      this.checkList = [];
      this.oil_code = "";
      this.oil_name = "";
      this.date = [];
      this.reviewed_status = 0;
      this.currentPage = 1;
      this.category_id = "";
      this.getList();
    },
    //多选
    handleSelectionChange(val) {
      this.selectedIdArr = val.map((item) => {
        return item.oil_id;
      });
      this.selectedId = this.selectedIdArr.toString();
    },
    //全选
    toggleSelection() {
      if (this.checked) {
        this.tableData.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    addGaofang() {
      this.addShow = true;
    },
    editGaofang(oil_id, hospital_name) {
      this.currentId = oil_id;
      this.hospitalName = hospital_name;
      this.editShow = true;
    },
    closeDialog() {
      this.currentId = "";
      this.editShow = false;
      this.addShow = false;
      this.getList();
    },
    //上架
    upSell(oil_id) {
      let data = {
        oil_id,
        buy_status: 1,
      };
      this.axios
        .post("platform/Goods/offOnHospitalOintment", data)
        .then((res) => {
          if (res.code === 0) {
            this.$message.success("养生方已上架");
            this.getList();
          }
        });
    },
    //下架
    OffTheShelves(oil_id) {
      let data = {
        oil_id,
        buy_status: 2,
      };
      this.$confirm("下架后养生方将不可被购买，确认下架吗？", "提示信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.axios
            .post("platform/Goods/offOnHospitalOintment", data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("养生方已下架");
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    //删除
    delGoods(oil_id) {
      this.$confirm("删除不可恢复，请谨慎操作", "提示信息", {
        confirmButtonText: "确定",
        cancelButtonText: "我再想想",
      })
        .then(() => {
          this.axios
            .post("platform/Goods/delHospitalOintment", { oil_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("养生方已删除");
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    //批量上架
    upSellAll() {
      if (!this.selectedId) {
        this.$message.error("请先选择需要操作的养生方");
        return false;
      }
      this.upSell(this.selectedId);
      setTimeout(() => {
        this.checked = false;
      }, 1000);
    },
    //批量下架
    OffTheShelvesAll() {
      if (!this.selectedId) {
        this.$message.error("请先选择需要操作的养生方");
        return false;
      }
      this.OffTheShelves(this.selectedId);
      setTimeout(() => {
        this.checked = false;
      }, 1000);
    },
    //批量删除
    delAll() {
      if (!this.selectedId) {
        this.$message.error("请先选择需要操作的养生方");
        return false;
      }
      this.delGoods(this.selectedId);
      setTimeout(() => {
        this.checked = false;
      }, 1000);
    },
    //在列表编辑库存价格
    editGoods(row) {
      let regPrice = /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/;
      let regStock = /^\d{0,6}$/;
      if (!regPrice.test(row.price)) {
        this.$message.error("价格请输入2位小数以内数字");
        return false;
      }
      if (row.stock < 0) {
        this.$message.error("库存请输入6位以内正整数");
        return false;
      }
      if (!regStock.test(row.stock)) {
        this.$message.error("库存请输入6位以内正整数");
        return false;
      }
      let data = {
        oil_id: row.oil_id,
        price: row.price,
        stock: row.stock,
      };
      return this.axios
        .post("platform/Goods/editOintmentPriceStock", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("养生方信息已经更改");
            this.getList();
          }
        });
    },
    //获取膏方分类
    getMedicineOintmentCategory() {
      let data = { type: 1 };
      this.axios
        .post("platform/Goods/getMedicineOintmentCategory", data)
        .then((res) => {
          this.categoryList = res.data.list;
        });
    },
  },
};
</script>

<style lang='scss' scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  position: relative;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  .item {
    margin-right: 30px;
    margin-bottom: 10px;
  }
}
.btnbox {
  text-align: left;
  margin: 20px 0;
  padding-left: 14px;
}
.dialog {
  padding: 20px;
}
</style>
<style lang="scss">
.mycheck .el-checkbox-group {
  display: flex;
  flex-direction: column;
  .el-checkbox {
    margin-bottom: 5px;
  }
}
</style>